import { splitUid, getNodeLabel, getUid, getMemberKeys } from 'Services/WeaverUtils'
import {
  setFilteredNodesByGraph
  setFilteredNodesByRelation
  setFilteredNodesByType
  setFilteredRelationsByKey
} from 'Actions/graphFilter'
import { store } from '~/Store'


export flatMapUnique = _.flow(_.flatMap, _.uniq)
getNodeIds = (nodes) -> _.map(nodes, (_, id) -> splitUid(id)[0])

export filterNodesByGraph = ->
  { graph: { graphData: { nodes }}, graphFilter: { graphFilters }} = store.getState()
  nodesToDisable = []
  disabledGraphs = _.map(_.filter(graphFilters, ['enabled', false]), 'id')

  if disabledGraphs.length > 0
    nodesToDisable = _.map(_.filter(nodes, (node) ->
      node.graph in disabledGraphs
    ), 'id')

  setFilteredNodesByGraph(nodesToDisable)

export filterNodesByType = ->
  { graph: { graphData: { nodes }}, graphFilter: { typeFilters }} = store.getState()
  nodeIds = getNodeIds(nodes)
  nodesToDisable = []

  disabledTypes = _.map(_.filter(typeFilters, ['enabled', false]), ({id}) -> id)
  enabledTypes = _.map(_.filter(typeFilters, ['enabled', true]), ({id}) -> id)

  if _.size(disabledTypes) > 0
    q = new Weaver.Query()
      .restrict(nodeIds)
      .hasRelationOut(getMemberKeys())

    nodesToDisable = _.reduce(await q.find(), (acc, node) ->
      for memberKey in getMemberKeys()
        for type in node.relation(memberKey).all()
          if getUid(type) in enabledTypes
            return acc
          else
            return [ acc..., getUid(node) ]
    , [])

  setFilteredNodesByType([nodesToDisable..., disabledTypes...])

export filterNodesByRelation = ->
  { graph: { graphData: { edges }}, graphFilter: { relationFilters }} = store.getState()
  nodesToDisable = []
  disabledRelations = _.map(_.filter(relationFilters, ['enabled', false]), 'key')

  if disabledRelations.length > 0
    nodesToCheck = _.reduce(edges, (acc, edge) ->
      if edge.key in disabledRelations
        [
          acc...
          edge.to
          edge.from
        ]
      else
        acc
    , [])

    nodesToDisable = _.reduce(nodesToCheck, (acc, node) ->
      hasVisibleRelations = _.filter(edges, (edge) ->
        edge.key not in disabledRelations and (edge.to is node or edge.from is node)
      ).length > 0

      if not hasVisibleRelations
        [
          acc...
          node
        ]
      else
        acc
    , [])

  setFilteredNodesByRelation(nodesToDisable)

export filterRelationsByKey = ->
  {
    graph: {
      graphData: {
        edges
      }
    }
    graphFilter: {
      filteredNodes
      relationFilters
    }
  } = store.getState()

  filteredNodes = flatMapUnique(filteredNodes)
  disabledRelations = _.map(_.filter(relationFilters, ['enabled', false]), 'key')

  setFilteredRelationsByKey(
    _.uniq(
      _.reduce(_.filter(edges, (edge) ->
        edge.key in disabledRelations or
        edge.from in filteredNodes or
        edge.to in filteredNodes
      ), (acc, edge) ->
        [
          acc...
          edge._id
          edge.id
        ]
      , [])
    )
  )

export getGraphs = ({ selectedItems }) ->
  { graph: { graphData: { nodes }}} = store.getState()
  graphs = _.uniq(_.keys(nodes).map((id) -> splitUid(id)[1]))
  defaultGraph = graphs.find((graph) -> graph is undefined)

  _.reduce(graphs, (acc, graph, count) ->
    id = graph
    res = { acc... }
    if id is undefined
      res.default = {
        enabled: if item = selectedItems.find((item) -> item.id is undefined) then item.enabled else true
        id: undefined
        label: 'Default Graph'
      }
    else
      res[id] = {
        id
        enabled: if item = selectedItems.find((item) -> item.id is id) then item.enabled else true
        label: id
      }
    res
  , {})

parseFilteredTypesList = (types, selectedItems) ->
  types.reduce((acc, { id, graph, label }) ->
    id = getUid(id, graph)
    {
      acc...
      [id]: {
        id
        enabled: if item = selectedItems.find((item) -> item.id is id) then item.enabled else true
        label
      }
    }
  , {})

export getFilteredTypes = ({ nodes, memberKeys, selectedItems, types }) ->
  nodeIds = _.map(nodes, (_, id) -> splitUid(id)[0])
  types = types.filter(({ id, graph }) -> nodes[getUid(id, graph)])
  parseFilteredTypesList(types, selectedItems)
